document.addEventListener('DOMContentLoaded', function () {

  /* mobile nav */
  var toggle = document.querySelector('.nav-toggle');
  var nav = document.querySelector('.main-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('open');
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { nav.classList.remove('open'); });
    });
  }

  /* file input label */
  var fileInput = document.getElementById('bijlage');
  var fileName = document.getElementById('file-name');
  if (fileInput && fileName) {
    fileInput.addEventListener('change', function () {
      if (fileInput.files && fileInput.files.length > 0) {
        var names = Array.from(fileInput.files).map(function (f) { return f.name; });
        fileName.textContent = names.join(', ');
      } else {
        fileName.textContent = '';
      }
    });
  }

  /* priority pills (visual only — value is computed server-side from het abonnement) */
  var pills = document.querySelectorAll('.priority-pill');
  var priorityField = document.getElementById('prioriteit');
  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      pills.forEach(function (p) { p.classList.remove('active'); });
      pill.classList.add('active');
      if (priorityField) priorityField.value = pill.dataset.value;
    });
  });

  /* intake form submission */
  var form = document.getElementById('hr-vraag-form');
  if (form) {
    var status = document.getElementById('form-status');

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var required = ['bedrijfsnaam', 'naam', 'email', 'onderwerp', 'vraag'];
      for (var i = 0; i < required.length; i++) {
        var el = document.getElementById(required[i]);
        if (el && !el.value.trim()) {
          status.textContent = 'Vul alle verplichte velden in voordat je verstuurt.';
          status.className = 'form-status err';
          el.focus();
          return;
        }
      }

      var consent = document.getElementById('akkoord');
      if (consent && !consent.checked) {
        status.textContent = 'Bevestig dat de gegevens kloppen om te kunnen versturen.';
        status.className = 'form-status err';
        return;
      }

      /* ----------------------------------------------------------------
         Shopify-integratie: vervang dit blok door een POST naar
         "/contact#ContactForm" (Shopify's ingebouwde contactformulier-
         engine) of naar een app-proxy endpoint van een formulieren-app
         die bijlages ondersteunt. Zie README in de projectmap.
         ---------------------------------------------------------------- */
      status.textContent = 'Versturen…';
      status.className = 'form-status';

      setTimeout(function () {
        status.textContent = 'Bedankt — je HR-vraag is binnengekomen. We reageren binnen de reactietermijn van je abonnement.';
        status.className = 'form-status ok';
        form.reset();
        if (fileName) fileName.textContent = '';
      }, 700);
    });
  }
});
